<!--我的招商活动 新建招商活动 快手指定团长下拉框-->
<template>
	<div class="institutionSearchSelect">
		<el-select class="multi" v-model="search_type" placeholder="请选择">
			<el-option v-for="(item, index) in searchTypeArr" :label="item.label" :value="item.value" :key="index"></el-option>
		</el-select>
		<institutionSelect
			class="dr-select"
			@input="input"
			@change="change"
			:search_type="search_type"
			:platformId="platformId"
			:valueKey="valueKey"
			:multiple-limit="10"
			multiple
			collapse-tags
			placeholder="请输入/选择"
		/>
	</div>
</template>
<script>
import institutionSelect from '@/components/business/institutionSelect';
export default {
	name: 'institutionSearchSelect',
	components: {
		institutionSelect,
	},
	props: {
		searchTypeArr: {
			type: Array,
			default: () => [],
		},

		platformId: {
			type: [Number, String],
			default: '',
		},
		valueKey: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			search_type: 'institutionName',
		};
	},
	methods: {
		input(e) {
			this.$emit('input', e);
		},
		change(e, obj) {
			this.$emit('change', e, obj);
		},
	},
};
</script>
<style lang="less" scoped>
.institutionSearchSelect {
	.multi {
		/deep/ .el-input {
			width: 120px;
		}
		/deep/ .el-input__inner {
			border-right: none;
			border-color: #e3e3e3;
			border-top-left-radius: 2px;
			border-bottom-left-radius: 2px;
		}
	}
	.dr-select {
		/deep/ .el-input__inner {
			border-top-right-radius: 2px;
			border-bottom-right-radius: 2px;
		}
	}
	/deep/ .el-input__inner {
		border-radius: 0px;
	}
	/deep/ .input-with-select .el-input-group__prepend {
		background-color: #fff;
	}
}
</style>
